module.exports = __webpack_public_path__ + "static/media/image-card-4.7475ba54.png";